import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AddressSuggestion } from "@shared-kernel/application/ports/public/public-repository";
import type { SUPPORTED_COUNTRY } from "@shared-kernel/domain/types/supported-country";

export const searchAddresses = createAsyncThunk<
  AddressSuggestion[],
  { query: string; sessionToken: string; country: SUPPORTED_COUNTRY },
  { extra: Partial<Dependencies> }
>("shared/addresses/search", async ({ query, sessionToken, country }, { extra: { publicRepository } }) => {
  return publicRepository!.searchAddresses(query, sessionToken, country);
});
